import { render, staticRenderFns } from "./Metrics.vue?vue&type=template&id=2ad0ece2&scoped=true"
import script from "./Metrics.vue?vue&type=script&lang=js"
export * from "./Metrics.vue?vue&type=script&lang=js"
import style0 from "./Metrics.vue?vue&type=style&index=0&id=2ad0ece2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad0ece2",
  null
  
)

export default component.exports